


























































































































































































import { Component, Prop } from 'vue-property-decorator';
import {
  GridApi,
  GridOptions,
  GridReadyEvent,
  ICellRendererParams,
} from 'ag-grid-community';

import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { LoadingService } from '@/services/loadingService';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { Funcionalidades } from '@/config/funcionalidades';
import { Snotify } from '@/snotify/Snotify';
import BuscadorOperacionCrud from '@/reusable/Grid/BuscadorOperacionCrud.vue';
import StepTitle from '@/reusable/Mantenedor/StepTitle.vue';
import {
  codigoAccionesMenuItem,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import { fetchReportesSerie } from '../fetchReporteSerie';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import { actionsEvent } from '@/setup';
import Confirmation from '@/components/Confirmation.vue';

@Component({
  components: {
    StepTitle,
    BuscadorOperacionCrud,
    MantenedorGridSinCodigo,
    FormFieldsContainer,
    'app-confirmacion': Confirmation,
  },
})
export default class TelcoFormApn extends ComponenteBase {
  readonly funcionalidad: Funcionalidades =
    Funcionalidades.MantenedorTelcoEditarApn;
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: null }) telcoid: any;

  /* ComponenteBase */
  ordesList: any[] = [];
  showReporteGeneradoCrearApn: boolean = false;
  showReporteGeneradoEditarApn: boolean = false;
  dialogConfirmacion: boolean = false;
  id_apn: any = '';
  idEliminar: any = '';
  telcoidEliminar: any = '';
  nombreApnElminar: any = '';
  currentApnName: string = '';

  readonly codigoAccionesMenuItem = Object.values(codigoAccionesMenuItem);

  /* aggrid */

  gridApi: GridApi = null;

  /* template */

  readonly gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'TelcoId',
        field: 'telcoid',
        lockVisible: true,
        hide: true,
      },
      {
        headerName: 'Id',
        field: 'telcoapnid',
        lockVisible: true,
      },
      {
        headerName: 'APN',
        field: 'telcoapnname',
        lockVisible: true,
      },
      {
        headerName: 'Observaciones',
        field: 'telcoobservaciones',
        lockVisible: true,
      },
    ],
    pagination: true,
    paginationPageSize: 5,
    onGridReady: this.handleGridReady,
  };

  formFields: FormFieldDefMap = {
    id: {
      label: 'Id',
      id: '',
      value: '',
    },
    apn: {
      label: 'APN',
      id: '',
      value: '',
    },
    observaciones: {
      label: 'Observaciones',
      id: '',
      value: '',
    },
  };

  crear_apn() {
    this.formFields.id.value = this.id_apn;
    this.showReporteGeneradoCrearApn = true;
  }
  closeReporteApn() {
    Object.keys(this.formFields).forEach(key => {
      if (key !== 'id') {
        this.formFields[key].value = '';
      }
    });
    this.showReporteGeneradoCrearApn = false;
  }
  async guardarApn() {
    let self = this;
    if (this.formFields.apn.value == '') {
      self.$snotify.error('Debe incluir el nombre de la APN', {
        timeout: 3000,
      });
      this.loadingService.hideLoading();
      return;
    }

    return fetchReportesSerie(
      {
        usuarioid: JSON.parse(localStorage.getItem('user')).id,
        usuariorut: JSON.parse(localStorage.getItem('user')).rutClienteDefecto,
        clienteid: JSON.parse(localStorage.getItem('clienteDefecto')),
        bmoduloid: this.funcionalidad,
        telcoid: this.telcoid,
        telcoapnid: this.formFields.id.value,
        telcoapnname: this.formFields.apn.value,
        telcoobservaciones: this.formFields.observaciones.value,
      },
      'mantenedor_telco/crear_apn'
    )
      .then(async (data: any) => {
        if (self.formFields.apn.value == '') {
          self.$snotify.error('El campo APN debe ser diligenciado', {
            timeout: 3000,
          });
        }
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.ordesList = await this.getReportes(this.telcoid);
          this.gridApi.setRowData(this.ordesList);

          self.$snotify.success(
            'Ha creado con éxito el APN :' + this.formFields.apn.value,
            { timeout: 3000 }
          );
          this.formFields.apn.value = '';
          this.formFields.observaciones.value = '';
          this.showReporteGeneradoCrearApn = false;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, {
            timeout: 3000,
          });
          return;
        }
      })
      .catch((error: any) => {
        self.$snotify.error(
          'Ha ocurrido un error al crear el APN :' + this.formFields.apn.value,
          { timeout: 3000 }
        );
        this.closeReporteApnEditar();
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }
  readonly $snotify: Snotify = null;
  readonly loadingService = new LoadingService();

  async getReportes(telcoid: any) {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie({ telcoid: self.telcoid }, 'mantenedor_telco/apn')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.id_apn = Number(data.data.CONTADOR[0].max) + 1;
          return data.data.data.LISTA;
        } else {
          this.id_apn = 1;
          return;
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }
  async handleGridReady(event: GridReadyEvent) {
    this.ordesList = await this.getReportes(this.telcoid);
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }
  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };

  accionEditarApn: PermisoAccion = {
    accionCodigo: 97,
    visible: false,
  };

  accionElimnarApn: PermisoAccion = {
    accionCodigo: 96,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [
    this.accionConsultar,
    this.accionEditarApn,
    this.accionElimnarApn,
  ];
  constructor() {
    super();
    actionsEvent.onEditarApn(this.handleVerEditarClickApn);
    actionsEvent.onEliminarApn(this.handleElminarApn);
  }
  handleVerEditarClickApn(params: ICellRendererParams) {
    this.showReporteGeneradoEditarApn = true;
    this.currentApnName = params.data.telcoapnname;
    (this.formFields.id.value = params.data.telcoapnid),
      (this.formFields.apn.value = params.data.telcoapnname),
      (this.formFields.observaciones.value = params.data.telcoobservaciones),
      (this.telcoid = params.data.telcoid);
  }
  async editarApn() {
    let self = this;
    this.loadingService.showLoading();
    if (this.formFields.apn.value == '') {
      self.$snotify.error('Debe incluir el nombre de la APN', {
        timeout: 3000,
      });
      this.loadingService.hideLoading();
      return;
    }

    return fetchReportesSerie(
      {
        usuarioid: JSON.parse(localStorage.getItem('user')).id,
        usuariorut: JSON.parse(localStorage.getItem('user')).rutClienteDefecto,
        clienteid: JSON.parse(localStorage.getItem('clienteDefecto')),
        telcoapnname: this.formFields.apn.value,
        telcoapnid: this.formFields.id.value,
        telcoid: this.telcoid,
        bmoduloid: this.funcionalidad,
        telcoobservaciones: this.formFields.observaciones.value,
        current_apn_name: this.currentApnName,
      },
      'mantenedor_telco/editar_apn'
    )
      .then(async (data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.ordesList = await this.getReportes(this.telcoid);
          this.gridApi.setRowData(this.ordesList);
          this.formFields.apn.value = '';
          this.formFields.observaciones.value = '';
          this.showReporteGeneradoEditarApn = false;
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, {
            timeout: 3000,
          });
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
        this.closeReporteApnEditar();
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  closeReporteApnEditar() {
    Object.keys(this.formFields).forEach(key => {
      if (key.toLowerCase() !== 'id') {
        this.formFields[key].value = '';
      }
    });
    this.showReporteGeneradoEditarApn = false;
  }

  handleElminarApn(params: ICellRendererParams) {
    this.idEliminar = params.data.telcoapnid;
    this.telcoidEliminar = this.telcoid;
    this.dialogConfirmacion = true;
    this.nombreApnElminar = params.data.telcoapnname;
  }
  async confirmCallback(val: boolean) {
    this.dialogConfirmacion = false;
    let self = this;

    this.dialogConfirmacion = false;

    if (val) {
      let self = this;
      this.loadingService.showLoading();

      return fetchReportesSerie(
        {
          usuarioid: JSON.parse(localStorage.getItem('user')).id,
          usuariorut: JSON.parse(localStorage.getItem('user'))
            .rutClienteDefecto,
          bmoduloid: this.funcionalidad,
          clienteid: JSON.parse(localStorage.getItem('clienteDefecto')),
          telcoid: self.telcoidEliminar,
          telcoapnid: self.idEliminar,
        },
        'mantenedor_telco/eliminar_apn'
      )
        .then(async (data: any) => {
          if (data.data.CODIGO_RESPUESTA == '1') {
            this.ordesList = await this.getReportes(this.telcoid);
            this.gridApi.setRowData(this.ordesList);

            self.$snotify.success(data.data.MENSAJE_RESPUESTA, {
              timeout: 3000,
            });
          } else {
            self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          }
        })
        .catch((error: any) => {
          self.$snotify.error('Ocurrió un error', { timeout: 3000 });
        })
        .finally(() => {
          this.loadingService.hideLoading();
          return null;
        });
    }
  }
}
